import { resolverContextoFinanciero, safeMoneyNumber } from "./contextoFinanciero";

const getPropiedadValor = (propiedad = {}, metodo = "igual") => {
  if (metodo === "m2") {
    return safeMoneyNumber(propiedad.metros2);
  }

  if (metodo === "precio_venta") {
    return safeMoneyNumber(
      propiedad.precioVenta ??
      propiedad.precioFinanciado ??
      propiedad.precioContado
    );
  }

  return 1;
};

const isPropiedadActiva = (propiedad = {}) => propiedad.activo !== false;

const getPropiedadesParaContexto = ({ contexto, propiedades = [] }) => {
  const base = propiedades.filter(isPropiedadActiva);

  if (contexto.fraccionamientoId) {
    return base.filter((p) => p.fraccionamientoId === contexto.fraccionamientoId);
  }

  if (contexto.proyectoId) {
    return base.filter((p) => p.proyectoId === contexto.proyectoId);
  }

  return [];
};

export const calcularProrrateoParaPropiedad = ({
  propiedad = {},
  gastos = [],
  propiedades = [],
  catalogos = {},
} = {}) => {
  const propiedadId = propiedad.id;
  if (!propiedadId) {
    return {
      totalProrrateado: 0,
      asignaciones: [],
    };
  }

  const asignaciones = [];

  gastos.forEach((gasto) => {
    if (gasto.capitalizable !== true) return;
    if (gasto.propiedadId) return;

    const metodo = gasto.metodoProrrateo || "ninguno";
    if (metodo === "ninguno") return;

    const contexto = resolverContextoFinanciero(gasto, catalogos);
    if (contexto.nivel === "administrativo") return;

    if (contexto.nivel === "propiedad") {
      if (contexto.propiedadId !== propiedadId) return;

      const importe = safeMoneyNumber(gasto.importe);
      asignaciones.push({
        gastoId: gasto.id,
        proveedorNombre: gasto.proveedorNombre || "",
        referencia: gasto.referencia || "",
        importe,
        montoAsignado: importe,
        metodo: "directo_obra",
        factor: 1,
        baseCount: 1,
        contexto,
      });
      return;
    }

    const propiedadesBase = getPropiedadesParaContexto({ contexto, propiedades });
    const participa = propiedadesBase.some((p) => p.id === propiedadId);
    if (!participa || propiedadesBase.length === 0) return;

    const pesos = propiedadesBase.map((p) => ({
      id: p.id,
      peso: getPropiedadValor(p, metodo),
    }));

    const totalPeso = pesos.reduce((acc, p) => acc + p.peso, 0);
    const pesoPropiedad = pesos.find((p) => p.id === propiedadId)?.peso || 0;
    const factor = totalPeso > 0
      ? pesoPropiedad / totalPeso
      : 1 / propiedadesBase.length;
    const importe = safeMoneyNumber(gasto.importe);
    const montoAsignado = importe * factor;

    asignaciones.push({
      gastoId: gasto.id,
      proveedorNombre: gasto.proveedorNombre || "",
      referencia: gasto.referencia || "",
      importe,
      montoAsignado,
      metodo,
      factor,
      baseCount: propiedadesBase.length,
      contexto,
    });
  });

  return {
    totalProrrateado: asignaciones.reduce((acc, a) => acc + a.montoAsignado, 0),
    asignaciones,
  };
};
